import { render, staticRenderFns } from "./AddFile.vue?vue&type=template&id=5390de9e&scoped=true&"
import script from "./AddFile.vue?vue&type=script&lang=js&"
export * from "./AddFile.vue?vue&type=script&lang=js&"
import style0 from "./AddFile.vue?vue&type=style&index=0&id=5390de9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390de9e",
  null
  
)

export default component.exports